import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingIndicator from './LoadingIndicator';

interface AdminRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Route guard that only allows admin users to access admin-only pages
 * Non-admin users are redirected to the main dashboard
 */
const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children }) => {
  const { user, loading, userRole } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return <LoadingIndicator />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin
  if (userRole !== 'admin') {
    // Non-admins get redirected to main dashboard
    return <Navigate to="/" replace />;
  }

  // User is admin, allow access
  return <>{children}</>;
};

export default AdminRouteGuard;

